// PrivacyPolicy.jsx

import React from 'react';
import './styles/PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p>
        At Dels Music Foundation, your privacy is of utmost importance to us. This policy
        outlines how we collect, use, and safeguard your personal information.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We may collect personal information such as your name, email address, and payment details
        when you make a donation through our website using PayPal.
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To process your donations securely.</li>
        <li>To send you receipts or donation confirmations.</li>
        <li>To communicate updates about the foundation and upcoming events, if opted in.</li>
      </ul>

      <h2>How We Protect Your Information</h2>
      <p>
        We implement industry-standard measures to protect your data. Payment information is
        processed securely through PayPal, and we do not store sensitive financial details on
        our servers.
      </p>

      <h2>Your Privacy Rights</h2>
      <p>
        You have the right to access, update, or delete your personal information. For any such
        requests, please contact us directly.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about our privacy policy, please refer to the contact us page.
      </p>
    </div>
  );
};

export default PrivacyPolicy;